import React, { useState } from 'react';
import { AdjudicationDialog } from '../components/claim/AdjudicationDialog';
import DenialsFilters from './denials/DenialsFilters';
import DenialsHeader from './denials/DenialsHeader';
import DenialsStatsCards from './denials/DenialsStatsCards';
import DenialsTable, { TriageConfirmDialog } from './denials/DenialsTable';
import TopReasonsPanel from './denials/TopReasonsPanel';
import { useDenials } from './denials/useDenials';

/**
 * Denials & Rejections Dashboard — `/claims/denials`.
 * Aggregates 835/277CA/TA1 denial signals into a CARC-bucketed view with
 * one-click "Fix and resubmit" CTAs for billers.
 */
const DenialsPage = () => {
  const d = useDenials();
  const [adjudicationClaim, setAdjudicationClaim] = useState(null);
  const [pendingTriage, setPendingTriage] = useState(null);

  return (
    <div className="space-y-5 animate-fade-in" data-testid="denials-page">
      <DenialsHeader
        onRefresh={d.refresh}
        onExport={d.exportCsv}
        exporting={d.exporting}
        total={d.total}
      />

      <DenialsStatsCards summary={d.summary} loading={d.summaryLoading} />

      <TopReasonsPanel
        summary={d.summary}
        filters={d.filters}
        onCarcSelect={(code) => d.updateFilter('carc_code', code)}
        on277Select={(code) => d.updateFilter('error_code', code)}
      />

      <DenialsFilters
        filters={d.filters}
        onChange={d.updateFilter}
        onReset={d.resetFilters}
      />

      <DenialsTable
        rows={d.rows}
        total={d.total}
        totalPages={d.totalPages}
        page={d.page}
        setPage={d.setPage}
        loading={d.listLoading}
        onAdjudication={(row) =>
          setAdjudicationClaim({ id: row.id, claim_number: row.claim_number })
        }
        onTriage={(row, action) => setPendingTriage({ row, action })}
      />

      <AdjudicationDialog
        claimId={adjudicationClaim?.id}
        claimNumber={adjudicationClaim?.claim_number}
        open={!!adjudicationClaim}
        onClose={() => setAdjudicationClaim(null)}
      />

      <TriageConfirmDialog
        pending={pendingTriage}
        onClose={() => setPendingTriage(null)}
        onConfirm={d.triageClaim}
      />
    </div>
  );
};

export default DenialsPage;
